module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-all-700-normal.woff?a457fde362a540fcadff80329251b6ae";